import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './app.tsx';
import { msalInstance } from './authConfig.ts';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<App instance={msalInstance} />
	</StrictMode>,
);
